<template>
    <div>
        <el-row class="u-mt-10 u-mb-20">
            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24" v-if="$store.state.user.tipo > 3 && $store.state.user.tipo <= 8">
                    <el-select @change="changeFiltros()" v-model="filtro.instituicao_id" filterable placeholder="Pesquisar Instituição" clearable>
                        <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"> </el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :xs="24" :sm="16" :md="16">
                    <el-input v-model="filtro.nome" placeholder="Pesquisar por nome" @keyup.native.enter="changeNome()"></el-input>
                </el-col>
                <el-col :xs="24" :sm="4" :md="8">
                    <el-select clearable placeholder="Data de agendamento" no-data-text="Selecione a data" v-model="filtro.data"  @change="changeFiltros()">
                        <el-option :key="1" label="06/01/2025" value="06/01/2025"></el-option>
                        <el-option :key="2" label="07/01/2025" value="07/01/2025"></el-option>
                        <el-option :key="3" label="08/01/2025" value="08/01/2025"></el-option>
                        <el-option :key="4" label="09/01/2025" value="09/01/2025"></el-option>
                        <el-option :key="5" label="10/01/2025" value="10/01/2025"></el-option>
                        <el-option :key="6" label="13/01/2025" value="13/01/2025"></el-option>
                        <el-option :key="7" label="14/01/2025" value="14/01/2025"></el-option>                       
                    </el-select>
                </el-col>
            </el-row>
        </el-row>

        <div class="container-table">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>Nome</th>
                        <th>Num. Matrícula</th>
                        <th>Telefone</th>
                        <th>Data do Agendamento</th>                        
                        <th>Instituição</th>
                        <th>Data da Inscrição</th>
                        <th>Ação</th>
                    </tr>
                </thead>
                <tbody v-if="statusList">
                    <tr v-for="item in items" :key="item.id">
                        <td>
                            <a href="javascript:void(0)">{{ item.matricula.nome_aluno }}</a>
                        </td>
                        <td>
                            {{ item.matricula.num_matricula }}
                        </td>
                        <td> {{ item.telefone }} </td>
                        <td>
                            {{ $moment(item.pre_matricula_vaga_agendamento.data).format('DD/MM/YYYY') }}
                        </td>                       
                        <td>                            
                            {{ item.pre_matricula_vaga_agendamento.instituicao.nome }}
                        </td>
                        <td>
                            {{ $moment(item.created_at).format('DD/MM/YYYY HH:mm') }}
                        </td>
                        <td>
                            <el-button :disabled="item.matricula_efetivada || item.cancelado || $store.state.user.tipo == 7" 
                                @click="matricularAluno(item)" :type="item.matricula_efetivada || 
                                item.cancelado ? 'info' : 'primary'" 
                                :title="item.matricula_efetivada ? 'Matriculado' : 
                                (item.cancelado ? 'Matrícula cancelada' : 'Matrícular aluno')" icon="el-icon-circle-check" size="mini" >
                            </el-button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div v-if="!statusList" class="u-text-center u-mt-25">
                <img src="/public/img/loading-bar.gif" />
            </div>
            <el-row :gutter="10" v-if="statusList">
                <el-col :xs="24" :sm="12" :md="12">
                    <div class="u-text-left u-mt-10">
                        Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} registros encontrados.
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12" v-if="paginate.qtdItens > 30">
                    <div class="u-text-right">
                            <el-pagination :current-page='paginate.page' class="u-mt-10" :total="paginate.qtdItens" @current-change="getPagePagination" :page-size="30" background layout="prev, pager, next" small></el-pagination>
                        </div>
                </el-col>
            </el-row>
        </div>

    </div>
</template>
<script>

export default {
    data: () => ({
        statusList: false,
        filtro: {
            nome: '',
            instituicao_id: '',
            data: ''
        },
        paginate: {
            page: 1,
            qtdItens: null,
            from: '',
            to: ''
        },
        items: [ ]
    }),
    mounted () {

        if(this.$store.state.config.instituicao && this.$store.state.user && this.$store.state.user.tipo <= 3){

            this.filtro.instituicao_id = this.$store.state.config.instituicao.id;
        }

        this.loadingInscritos()
    },
    methods: {
        changeNome(){

            this.filtro.idade = '';
            this.changeFiltros();
        },
        changeFiltros(){

            this.paginate.page = 1;
            this.loadingInscritos();
        },
        loadingInscritos(){

            this.statusList = false;
            this.items = [];

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/pre-matricula/getAllInscritosPaginate?page=` + this.paginate.page, this.filtro, this.$store.getters.getHeaderAuth).then(response => {

                this.items = response.data.data;
                this.paginate.qtdItens = response.data.total;
                this.paginate.from = response.data.from;
                this.paginate.to = response.data.to;
                this.statusList = true;

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        matricularAluno(item) { 
            
            let aluno = item.matricula.aluno_id;
                        
            this.$router.push(`/admin/matricula/passo-a-passo/${aluno}`);
        },
        getPagePagination(page){
          this.paginate.page = page;
          this.loadingInscritos();
        }
    },
    components:{  }
}
</script>